<div class="collapse-all-container">
  <div [ngClass]="disabled ? 'disabled-show-rules' : 'collapse-all'" (click)="!disabled && toggle()" l10nTranslate>
    <mat-icon class="collapse-icon" [svgIcon]="iconName"></mat-icon>
    <span class="collapse-label">{{ iconLabel }}</span>
  </div>
</div>
